import { computed, unref } from 'vue';

import { propsFactory, paramCase } from '@components/utils';

import type { MaybeRef } from '@components/utils';
import type { ComputedRef, PropType } from 'vue';

export type TStatus = typeof allowedStatus[number];
export interface IStatusProps {
  status: TStatus;
}
export interface IUseStatus {
  statusClasses: ComputedRef<string>;
}

export const allowedStatus = ['info', 'success', 'warning', 'error', 'progress'] as const;
export const makeStatusProps = propsFactory(
  {
    /**
     * Статус состояния
     */
    status: {
      type: String as PropType<TStatus>,
      default: 'info',
      available: allowedStatus,
      description: 'Статус',
      validator: (value: TStatus) => allowedStatus.includes(value)
    }
  },
  'status'
);

export function useStatus(props: MaybeRef<IStatusProps>, name: string): IUseStatus {
  const statusClasses = computed(() => {
    const { status } = unref(props);
    return `${paramCase(name)}__status--${status}`;
  });

  return { statusClasses };
}
